export enum EInternalPages {
    ShippingListUpload = 'Shipping list upload'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/internal.ts